import React, { useState, useEffect } from "react";
import moment from "moment";

const TwelveHourTimePicker = ({ value, onChange }) => {
  const [hour, setHour] = useState("08");
  const [minute, setMinute] = useState("00");
  const [ampm, setAmPm] = useState("AM");

  useEffect(() => {
    if (value) {
      const time = moment(value, "hh:mm A");
      setHour(time.format("hh"));
      setMinute(time.format("mm"));
      setAmPm(time.format("A"));
    }
  }, [value]);

  useEffect(() => {
    const formattedTime = `${hour}:${minute} ${ampm}`;
    if (onChange) {
      onChange(formattedTime);
    }
  }, [hour, minute, ampm]);

  return (
    <div className="flex items-center gap-2">
      <select
        value={hour}
        onChange={(e) => setHour(e.target.value)}
        className="border border-[#D2D2D2] font-poppins px-2 py-1 rounded text-[12px]"
      >
        {Array.from({ length: 12 }, (_, i) => {
          const h = (i + 1).toString().padStart(2, "0");
          return (
            <option key={h} value={h}>
              {h}
            </option>
          );
        })}
      </select>

      <select
        value={minute}
        onChange={(e) => setMinute(e.target.value)}
        className="border border-[#D2D2D2] px-2 py-1 font-poppins rounded text-[12px]"
      >
        {["00", "15", "30", "45"].map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>

      <select
        value={ampm}
        onChange={(e) => setAmPm(e.target.value)}
        className="border border-[#D2D2D2]  px-2 py-1 font-poppins rounded text-[12px]"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
};

export default TwelveHourTimePicker;
